<template>
  <div id="AlertMessage" v-if="StatusShowMsg">

    <v-row>

      <v-col cols="12">

        <v-alert
            dense
            text
            type="success"
            v-if="StatusAlert=='success'"
        >
          <h3>{{ MsgText }}</h3>
        </v-alert>

        <v-alert
            dense
            outlined
            type="error"
            v-else-if="StatusAlert=='error'"
        >
          <h3>{{ MsgText }}</h3>
        </v-alert>

      </v-col>

    </v-row>
  </div>
</template>

<script>
export default {
  name: "AlertMessage",
  data() {
    return {}
  },
  props: {
    StatusShowMsg: {
      type: Boolean
    },
    MsgText: {
      type: String
    },
    StatusAlert: {
      type: String
    }
  },
}
</script>

<style scoped>

</style>